import React, {useState} from 'react';
import './ContractProvize.css'; // Assuming you save the CSS in Contract.css
import razitko from '../../../img/razitko.png'
import Button from 'react-bootstrap/Button';
import fetchData from '../../../function/fetchData'
import SignatureColumn from './SignatureColumn';
import Spinner from 'react-bootstrap/Spinner';

const ContractCodex = ({server, token, data, tokenOfContract, alreadySigned , handleDone, setShowMessage}) => {
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState("")
    const type = 'contractCodex'
    const serverAddress = server + "api2/contractController.php"
    const [formData, setFormData] = useState({
        commission: data ? data.commission : '400,- Kč',
        commission2 : data ? data.commission2 : '3.000,- Kč',
        commission3 : data ? data.commission3 : '300,- Kč',
        commission4 : data ? data.commission4 : '1000,- Kč',
        commission5 : data ? data.commission5 : '1000,- Kč',
        commission6 : data ? data.commission6 : '150,- Kč',
        commission7 : data ? data.commission7 : '150,- Kč',
        commission8 : data ? data.commission8 : '40,- Kč',
        commission9 : data ? data.commission9 : '200,- Kč',
        commission10 : data ? data.commission10 : '600,- Kč',
        commission11: data ? data.commission11 : ' 600,- Kč',
        commission12 : data ? data.commission12 : '100,- Kč',
        employee: data ? data.employee : '',
        });


  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Odeslat
  const handleSubmit = (e) => {

    e.preventDefault();
    // Convert formData to JSON
    const json = JSON.stringify(formData);
    
    // Pošle data
    if(json && email.length > 5){
        setLoading(true)
        fetchData(serverAddress , {
            token: token,
            action: 'SAVE',
            type: type,
            formData: formData,
            email: email
        }).then( (res) => {
          setShowMessage('Dokument odeslán.')
          setLoading(false)
     
        })
    } else {
      alert('Vyplňte prosím email')
    }
  };

  console.log(server + "api2/saveSignatureController.php")

/// Uloží podpis
const sendSignatureToServer = async (dataUrl) => {
  // Concatenate the full URL
  const serverAddress = `${server}api2/saveSignatureController.php`;

  // Send the data to the server
  try {
    const response = await fetch(serverAddress, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: "SAVE_SIGNATURE",
        payload: {
          tokenOfContract: tokenOfContract,
          signature: dataUrl
        }
      }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const result = await response.json();
    console.log('Signature saved:', result);
    handleDone()
    setLoading(false)
  } catch (error) {
    console.error('Error:', error);
  }
};


  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }} className="contract">
    <h1>Sankční katalog pokut (dodatek pracovní smlouvy)</h1>
    <br />
    Zaměstnanec: <input type='text' className='niceInput' style={{width: 400}} name={'employee'} value={formData.employee} onChange={handleChange} readOnly={alreadySigned ? true : false} />
    <br />
    <br />
    <section>
      <h2>Přihlásit se do systému</h2>
      <p>
        Přihlásit se do systému v čase příchodu do práce a být připraven bezodkladně začít realizovat doručené obj. Přes aplikaci nebo přes telefonní dispečink.
      </p>
      <p><strong>ZPOŽDĚNÍ ZA KAŽDOU ZAPOČATOU HODINU – pokuta  <input type='text' className='niceInput' style={{width: 80}} name={'commission'} value={formData.commission} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Přihlášení řidiče do app. DRIVER</h2>
      <p>Přihlášení bude vždy v místě startovací zóny Na Moráni 5357 Chomutov.</p>
    </section>
    <br />
    <section>
      <h2>Připravenost plnit povinnosti</h2>
      <p>
        Být připraven plnit povinnosti zejména přijímat zakázky v každý námi určený den (s výjimkou námi odsouhlasené absence).
      </p>
      <p><strong>UKONČENÍ SPOLUPRÁCE ZE DNE NA DEN. Pokuta  <input type='text' className='niceInput' style={{width: 80}} name={'commission2'} value={formData.commission2} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Úprava a hygiena</h2>
      <p>
        Zaměstnanec je povinen chodit do práce řádně upravený, v čistém oblečení a dodržovat zásady osobní a provozní hygieny.
      </p>
      <p><strong>Pokuta  <input type='text' className='niceInput' style={{width: 80}} name={'commission3'} value={formData.commission3} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Profesionální jednání</h2>
      <p>
        Zaměstnanec bude při jednání, či odvozu z bodu A do bodu B jednat se zákazníky profesionálně, vstřícně, slušně a korektně v nejlepším zájmu dobrého jména společnosti GLOBAL PLUS.
      </p>
      <p><strong>Pokuta  <input type='text' className='niceInput' style={{width: 80}} name={'commission4'} value={formData.commission4} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Osobní údaje</h2>
      <p>Zaměstnanec nesmí předávat osobní číslo telefonní nebo sociální sítě.</p>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission5'} value={formData.commission5} onChange={handleChange} readOnly={alreadySigned ? true : false} />, na podruhé za stejný prohřešek konec spolupráce</strong></p>
    </section>
    <br />
    <section>
      <h2>Pro brigádníky</h2>
      <p>
        Auto bude po šichtě uklizené, navoněné a řádně bez poškození odstavené v místě Chomutov, Na Moráni 5357.
      </p>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission6'} value={formData.commission6} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Přijetí zakázky</h2>
      <p>Zakázka v aplikaci nepřijmuta do 3 minut od zadání zákazníka.</p>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission7'} value={formData.commission7} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Realizace zakázky</h2>
      <p>
        Zakázka, která nebyla včas v místě naložení uskutečněna a byla poslána tzv. Omluvenka viz. ADMIN účet GLOBAL PLUS.
      </p>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission8'} value={formData.commission8} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Provize</h2>
      <p>
        Provize budou uskutečněny majiteli každý započatý týden v neděli do 20 hod. Dále dokud provize nebude zaplacena v celkové 100% výši, nemají nárok na výplatu z Terminálu.
      </p>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission9'} value={formData.commission9} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Mystery kontrola</h2>
      <p>Neúspěšná kontrola.</p>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission10'} value={formData.commission10} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Ztráta magnetů</h2>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission11'} value={formData.commission11} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Docházkový systém</h2>
      <p>
        Docházkový systém na centrále bude vždy zapsán příchod a odchod vč. Počtu telefonů a aplikací a celou nařízenou šichtu.
      </p>
      <p><strong>Pokuta <input type='text' className='niceInput' style={{width: 80}} name={'commission12'} value={formData.commission12} onChange={handleChange} readOnly={alreadySigned ? true : false} /></strong></p>
    </section>
    <br />
    <section>
      <h2>Podepsání řidiči</h2>
      <p>Přiřazené čísla a jména a podpis řidičů KODEX SMLOUVY STVRZUJÍ: Vaněček Marek / jednatel</p>
    </section>
    <section>
    <br />  <br />
    <div>
    <br />
        <br />
        {alreadySigned && <img src={razitko} style={{width: 300}}/> }
        <p>________________________________</p>
        <p>Zaměstanavatel: Vaněček Marek</p>
        {!alreadySigned && tokenOfContract && <SignatureColumn sendSignatureToServer={sendSignatureToServer}/> }
        {alreadySigned && <img src={server +'api2/public/signature/' + tokenOfContract + '.png'}/>}
        <p>Zaměstnanec: </p>
      </div>
      <div style={{display:'flex' , justifyContent: 'flex-end'}}>
        {!tokenOfContract &&  <input type='text' className='niceInput' placeholder='email' name='email' value={email} onChange={(e) => setEmail(e.target.value)}/> }
        {!tokenOfContract && !loading && <Button variant="success" onClick={handleSubmit}>Odeslat</Button> }
        {!tokenOfContract && loading && <Button variant="secondary">Odesílám <Spinner animation="border" size='sm'/></Button> }
      </div>
    </section>
  </div>

    )
  }

  export default ContractCodex